import React from "react"
import styled from "styled-components"


const _NetworkBanner = styled.div`

    color: ${({ theme }) => theme.notMainChainTextColor};
    background-color: ${({ theme }) => theme.notMainChainBackgroundColor};

	font-size: 1.1rem;
	justify-content: space-between;
	overflow: hidden;
	padding: 1.2rem;
	outline: none;
	font-weight: bold;
	text-decoration: none;
	text-align: center;


	/* Tablets */
	@media (max-width: 1400px) {
		font-size: 0.95rem;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		font-size: 0.75rem;
	}

`;

function NetworkBanner(props) {
	return (
		<>
			{
				props.appChainID && props.supportedChains[props.appChainID] == undefined ?
					<_NetworkBanner>
						Please switch to a supported network 😊
					</_NetworkBanner>
				: <></>
			}
		</>
	)
}

export default NetworkBanner;